import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=cf52cc70&scoped=true&"
import script from "./MFooter.vue?vue&type=script&lang=js&"
export * from "./MFooter.vue?vue&type=script&lang=js&"
import style0 from "./MFooter.vue?vue&type=style&index=0&id=cf52cc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf52cc70",
  null
  
)

export default component.exports